import { useEffect, useState } from 'react';
import { getDatosJornadas } from '../services/asignacionPistaService';

// Fecha y sede de cada jornada: { [jornada]: { fecha: 'DD/MM/YYYY'|'', sede } }.
// Si falla la petición simplemente no se muestran (la pantalla no depende de esto).
export function useDatosJornadas(temporada) {
  const [datos, setDatos] = useState({});

  useEffect(() => {
    if (!temporada) {
      setDatos({});
      return undefined;
    }
    let cancelado = false;
    getDatosJornadas(temporada)
      .catch(() => [])
      .then((lista) => {
        if (cancelado) return;
        const mapa = {};
        (lista || []).forEach((d) => {
          const [a, m, dia] = (d.fecha || '').slice(0, 10).split('-');
          mapa[d.jornada] = { fecha: a ? `${dia}/${m}/${a}` : '', sede: d.sede || '' };
        });
        setDatos(mapa);
      });
    return () => { cancelado = true; };
  }, [temporada]);

  return datos;
}
